<template>
  <div>
    <div>
      <div class="col-md-12">
        <h1>Downloads</h1>
      </div>
    </div>
    <div>
      <div class="col-md-12">
        <ul>
          <li v-for="article in articles" :key="article.title">
            <a :href="article.url">{{ article.title }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
  export default {
    name: 'downloads',
    data() {
      return {
        articles: [
          {
            title: 'Company performance measurement for automobile companies: A composite indicator from an environmental perspective',
            url: "./static/articles/Article1.pdf"
          },
          {
            title: 'Measuring company performance from an environmental perspective: A composite indicator for truck manufacturers',
            url: "./static/articles/Article2.pdf"
          },
          {
            title: 'Exploring company performance measurement for truck manufacturers',
            url: "./static/articles/Article3.pdf"
          },
          {
            title: 'Constructing composite indicators of company performance:  an overview and a proposal for truck manufacturers',
            url: "./static/articles/Article4.pdf"
          },
          {
            title: 'Composite indicators of company performance: a literature survey',
            url: "./static/articles/Article5.pdf"
          },
          {
            title: 'A company performance index for motor vehicle manufacturers with environmental concerns',
            url: "./static/articles/Article6.pdf"
          },
          {
            title: 'An integrated framework of company performance trend analysis for motor vehicle manufacturers',
            url: "./static/articles/Article7.pdf"
          }
        ]
      }
    }
  }
</script>
